import { useState } from "react";

const BoardRadiobutton = () => {
    // 초기값 설정 : {[key: name]: value}
    const [selectData, setSelectData] = useState({ name: "map" });

    // input[type=radio] value 값을 바꿔줌
    const handleChange = (e) => {
        const { name, value } = e.target;
        setSelectData({
            [name]: value,
        });
    };

    return (
        <div>
            <input
                type="radio"
                name="map"
                value="map"
            >
            </input>
            제목
            <input
                type="radio"
                name="map2"
                value="map2"
            >
            </input>
            내용
            <input
                type="radio"
                name="map3"
                value="map3"
            >
            </input>
            작성자
        </div>
    );
};

export default BoardRadiobutton;